module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Requisições associadas a \""), _c('b', [_vm._v(_vm._s(_vm.workflow.name))]), _vm._v("\"")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "tab",
    class: 'active',
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', [_vm._v("Requisições "), _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.count))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    staticStyle: {
      "margin": "10px"
    },
    on: {
      "click": _vm.addFilterField
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-plus"
  }), _vm._v(" Adicionar Filtro\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(!_vm.fieldFilters.length) ? _c('p', {
    staticClass: "text-muted",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Nenhum filtro adicional aplicado.")]) : _vm._l((_vm.fieldFilters), function(fieldFilter, index) {
    return _c('div', {
      key: fieldFilter.field.objectId,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4 form-group"
    }, [_c('multiselect', {
      attrs: {
        "id": "formSelect",
        "label": "name",
        "track-by": "name",
        "options": _vm.formFields,
        "placeholder": "Selecione uma opção",
        "selectLabel": 'Pressione enter',
        "hide-selected": true
      },
      model: {
        value: (fieldFilter.field),
        callback: function($$v) {
          _vm.$set(fieldFilter, "field", $$v)
        },
        expression: "fieldFilter.field"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 text-center"
    }, [_c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(fieldFilter.operator))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-5 form-group"
    }, [_c('dynamic-form-field', {
      attrs: {
        "onChange": function () {},
        "formField": fieldFilter.field
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-sm-1 text-center"
    }, [_c('button', {
      staticClass: "btn btn-default btn-sm btn-danger glyphicon glyphicon-trash",
      on: {
        "click": function($event) {
          return _vm.removeFilter(index)
        }
      }
    })])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "title": "Download de Todas as Requisições"
    },
    on: {
      "click": _vm.downloadWorkflowRequests
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-download"
  }), _vm._v(" Download de Todas as Requisições\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm pull-right",
    on: {
      "click": _vm.getRequests
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok"
  }), _vm._v(" Aplicar Filtros\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })])])])]), _vm._v(" "), (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getRequests]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('span', {
      key: status.value,
      staticStyle: {
        "margin-left": "10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.statusFilter),
        expression: "statusFilter"
      }],
      attrs: {
        "type": "checkbox",
        "id": status.value
      },
      domProps: {
        "value": status.value,
        "checked": Array.isArray(_vm.statusFilter) ? _vm._i(_vm.statusFilter, status.value) > -1 : (_vm.statusFilter)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.statusFilter,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = status.value,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.statusFilter = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.statusFilter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.statusFilter = $$c
          }
        }, _vm.getRequests]
      }
    }), _vm._v(" "), _c('span', {
      attrs: {
        "for": status.value
      }
    }, [_vm._v(_vm._s(status.name))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getRequests.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), (_vm.requests.length > 0) ? _c('b-table', {
    attrs: {
      "id": "user-requests",
      "items": _vm.requests,
      "fields": _vm.requestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")])
      }
    }, {
      key: "workflow",
      fn: function(item) {
        return _c('span', {}, [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")])
      }
    }, {
      key: "currentStep",
      fn: function(item) {
        return [_vm._v("\n                " + _vm._s(item.value.get('name')) + "\n            ")]
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n            ")])
      }
    }], null, false, 1953540879)
  }) : _c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_vm._v("\n              Nenhuma requisição. "), (_vm.filter) ? _c('span', [_vm._v("(Tente remover o filtro e listar novamente)")]) : _vm._e()])]), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.count,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getRequests
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44d2ff38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkflowRequests.vue
// module id = 1445
// module chunks = 1